import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { HintTypeEnum } from '../../../hrm/models/hints-list.model';
import { getBinLocationHintsList } from '../../configs/hints.config';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from 'common/src/modules/rnpl-common/components/base-mega-hints/base-mega-hints.component';
import { BinLocationsTabsEnum } from '../../enums';

@Component({
  selector: 'rnpl-bin-location-mega-hint',
  templateUrl: './bin-location-mega-hint.component.html',
  styleUrls: ['./bin-location-mega-hint.component.scss']
})
export class BinLocationMegaHintComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {
  @Input() public isEdit: boolean;
  @Input() public activeTab: BinLocationsTabsEnum | string;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'WAREHOUSE.BIN_LOCATIONS'
    this.megaHintTimer = 800;
    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('isEdit') || changes.hasOwnProperty('activeTab')) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.complete();
        this.shepherdService.cancel();
        this.animationStateIsPaused$.next(false);
      }

      this.initHints();
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = getBinLocationHintsList(this.isEdit, this.activeTab)

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (
            !!hints.data.hints &&
            !!hints.data.hints.length &&
            !hints.data.hints[0].viewed &&
            hints.data.hints[0].type === HintTypeEnum.MEGA
          ) {
            this.isCloseHint$.next(false);
            this.startTimerMegaHint();
          } else {
            if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
              this.shepherdService.start();
            }
          }
        }
      })
  }
}
